import React from 'react';
import styled from 'styled-components';
import { Select } from 'shared/components';
import { MobileAppFlair } from 'types/graphql';
import useHasMobileApp from 'src/utils/use-has-mobile-app';

type MobileAppFlairSelectProps = {
  value: MobileAppFlair;
  onChange: (value: MobileAppFlair) => void;
};

/** Mobile flair style control; only rendered when a mobile app is configured. */
export function MobileAppFlairSelect({ value, onChange }: MobileAppFlairSelectProps): JSX.Element | null {
  const hasMobileApp = useHasMobileApp();

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    onChange(event.target.value as MobileAppFlair);
  };

  if (!hasMobileApp) {
    return null;
  }

  return (
    <Container>
      <Label>MOBILE APP DECORATION TYPE</Label>
      <Select fontSize='13px' height={45} onChange={handleChange} value={value} width='326px'>
        <option value={MobileAppFlair.none}>None</option>
        <option value={MobileAppFlair.angled}>Angled</option>
        <option value={MobileAppFlair.curved}>Curved</option>
        <option value={MobileAppFlair.jagged}>Jagged</option>
        <option value={MobileAppFlair.wavy}>Wavy</option>
      </Select>
    </Container>
  );
}

const Container = styled.div`
  margin-top: 10px;
`;

const Label = styled.div`
  display: block;
  font-size: 11px;
  font-weight: bold;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.grey[45]};
  padding-bottom: 10px;
`;
